module.exports = __webpack_public_path__ + "static/250526_Q1-2025_Investor_Call_Dial_in_information-43e69532fdc467bb18db8a5f0cc9f5e7.pdf";